<button class="btn btn-primary btn-sm" (click)="save()">Save</button><br>
<form [formGroup]="form">
    <quill-editor
      #editor
      formControlName="editor"
      placeholder="Enter Text"
      [modules]="quillConfig"
      format="html"
      style="display: grid"
    >
    </quill-editor>
  </form>


<!--   
  <p>mode: {{ format }}</p>
  
  <div>
    <pre>{{ form.value | json }}</pre>
  </div>

{{content}} -->

